<!-- @veltra/icons generated sha256:aeebdd801133cedf gen:8 source:src/svg/normal/key.svg -->
<script setup lang="ts">
defineOptions({ name: 'Key' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <path d="m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4M21 2l-9.6 9.6" />
    <circle cx="7.5" cy="15.5" r="5.5" />
  </svg>
</template>
